export default {
  articles: {
    title: {
      children: [
        ['paragraphs', 'title']
      ]
    },
    top: {
      children: [ ['paragraphs', 'columns'] ]
    },
    bottom: {
      title: {
        en: 'Recent Projects',
        ru: 'Последние проекты'
      },
      children: [ ['paragraphs', 'recent'] ]
    }
  },
  paragraphs: {
    title: {
      style: {
        title: {
          textAlign: 'center'
        }
      },
      title: {
        en: 'Alexander Kostrov',
        ru: 'Александр Костров'
      },
      children: [
        ['texts', 'title']
      ]
    },
    columns: {
      children: [
        ['paragraphs', 'summary'],
        ['paragraphs', 'education'],
        ['paragraphs', 'experience']
      ]
    },
    recent: {
      children: [
        ['paragraphs', 'appbooster'],
        ['paragraphs', 'mdl'],
        ['paragraphs', 'hospitality'],
        ['paragraphs', 'amqp'],
        ['paragraphs', 'tv'],
        ['paragraphs', 'backend'],
        ['paragraphs', 'gtd'],
        ['paragraphs', 'sudprof']
      ]
    },
    summary: {
      title: {
        en: 'Summary',
        ru: 'Инфо'
      },
      style: {
        title: {
          textAlign: 'center'
        },
        columns: {
          large: 4,
          middle: 4,
          small: 12
        }
      },
      children: [ ['texts', 'summary'] ]
    },
    education: {
      title: {
        en: 'Education',
        ru: 'Образование'
      },
      style: {
        title: {
          textAlign: 'center'
        },
        columns: {
          large: 4,
          middle: 4,
          small: 12
        }
      },
      children: [ ['texts', 'education'] ]
    },
    experience: {
      title: {
        en: 'Work Experience',
        ru: 'Опыт работы'
      },
      style: {
        title: {
          textAlign: 'center'
        },
        columns: {
          large: 4,
          middle: 4,
          small: 12
        }
      },
      children: [ ['texts', 'experience'] ]
    },
    appbooster: {
      children: [ ['texts', 'appbooster'] ]
    },
    mdl: {
      children: [ ['texts', 'mdl'] ]
    },
    hospitality: {
      children: [ ['texts', 'hospitality'] ]
    },
    amqp: {
      children: [ ['texts', 'amqp'] ]
    },
    tv: {
      children: [ ['texts', 'tv'] ]
    },
    backend: {
      children: [ ['texts', 'backend'] ]
    },
    gtd: {
      children: [ ['texts', 'gtd'] ]
    },
    sudprof: {
      children: [ ['texts', 'sudprof'] ]
    }
  },
  texts: {
    title: {
      style: {
        textAlign: {
          h4: 'center'
        }
      },
      html: {
        en: require('@/articles/title.md'),
        ru: require('@/articles/title_ru.md')
      }
    },
    summary: {
      style: {
        textAlign: {
          h4: 'center'
        }
      },
      html: {
        en: require('@/articles/summary.md'),
        ru: require('@/articles/summary_ru.md')
      }
    },
    education: {
      html: {
        en: require('@/articles/education.md'),
        ru: require('@/articles/education_ru.md')
      }
    },
    experience: {
      html: {
        en: require('@/articles/experience.md'),
        ru: require('@/articles/experience_ru.md')
      }
    },
    appbooster: {
      html: {
        en: require('@/articles/appbooster.md'),
        ru: require('@/articles/appbooster_ru.md')
      }
    },
    mdl: {
      html: {
        en: require('@/articles/mdl.md'),
        ru: require('@/articles/mdl_ru.md')
      }
    },
    hospitality: {
      html: {
        en: require('@/articles/hospitality.md'),
        ru: require('@/articles/hospitality_ru.md')
      }
    },
    amqp: {
      html: {
        en: require('@/articles/amqp_messaging.md'),
        ru: require('@/articles/amqp_messaging_ru.md')
      }
    },
    tv: {
      html: {
        en: require('@/articles/tv_guide.md'),
        ru: require('@/articles/tv_guide_ru.md')
      }
    },
    backend: {
      html: {
        en: require('@/articles/backend_customizations.md'),
        ru: require('@/articles/backend_customizations_ru.md')
      }
    },
    gtd: {
      html: {
        en: require('@/articles/gtd.md'),
        ru: require('@/articles/gtd_ru.md')
      }
    },
    sudprof: {
      html: {
        en: require('@/articles/sudprof.md'),
        ru: require('@/articles/sudprof_ru.md')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/about.js